"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
/* eslint-disable react/jsx-no-useless-fragment */
const react_1 = __importStar(require("react"));
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const Input_1 = __importDefault(require("~/components/UI/Input"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const useSelectedObjectSize_1 = __importDefault(require("~/hooks/useSelectedObjectSize"));
const selectors_1 = require("~/store/selectors");
const consts_1 = require("~/components/Cad3d/consts");
const consts_2 = require("~/consts/consts");
const consts_3 = require("~/components/Cad3d/consts/consts");
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const ItemPropertiesWidget_scss_1 = __importDefault(require("../ItemPropertiesWidget.scss"));
function ItemSizeEditor({ properties }) {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const size = (0, useSelectedObjectSize_1.default)();
    const isImperial = (0, react_redux_1.useSelector)(selectors_1.selectIsImperialMeasurementUsed);
    const selectedObjectsUUIDs = (0, react_redux_1.useSelector)(selectors_1.selectSelectedObjectsUUIDs);
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const [unitOfMeasurement, setUnitOfMeasurement] = (0, react_1.useState)('in');
    const [step, setStep] = (0, react_1.useState)(consts_1.consts.DEFAULT_EXTRUDE_STEP);
    const [min, setMin] = (0, react_1.useState)(0);
    const selectedObjects = (_a = Viewer_1.default.instance.getDesignProMain()) === null || _a === void 0 ? void 0 : _a.selectionTool.selectedObjects;
    const selectedBaseObject3D = selectedObjects;
    const isAngledSelected = selectedBaseObject3D && selectedBaseObject3D.length === 1 ? !!selectedBaseObject3D[0].scalingAngle : false;
    (0, react_1.useEffect)(() => {
        if (isImperial) {
            setStep(consts_1.consts.DEFAULT_EXTRUDE_STEP);
            setMin(1);
            setUnitOfMeasurement('in');
        }
        else {
            setStep(5);
            setMin(1 * consts_1.consts.INCH_TO_MM);
            setUnitOfMeasurement('mm');
        }
    }, [isImperial]);
    const updateObjectSize = (axis, value) => {
        Viewer_1.default.instance.changeItemSize(selectedObjectsUUIDs[0], {
            [axis]: value,
        }, isImperial);
    };
    const xAxisHandler = (value) => {
        updateObjectSize(consts_3.Axis.x, Number(value));
    };
    const yAxisHandler = (value) => {
        updateObjectSize(consts_3.Axis.y, Number(value));
    };
    const zAxisHandler = (value) => {
        updateObjectSize(consts_3.Axis.z, Number(value));
    };
    const getPropertyValue = (propertyName) => {
        if (!properties.length) {
            return null;
        }
        const propertyValue = properties.find((property) => property.property.name === propertyName);
        return propertyValue === null || propertyValue === void 0 ? void 0 : propertyValue.value;
    };
    if (!size || !Object.keys(size)) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            size.x && size.y ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['subtitle'] }, t('item.length') + unitOfMeasurement),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Input_1.default, { type: "number", lengthInput: true, key: `${selectedObjectsUUIDs[0]}-${isImperial}`, onChange: (value, error) => {
                            const handler = size.x > size.y ? xAxisHandler : yAxisHandler;
                            handler(value);
                        }, onInput: (value, error) => {
                            const handler = size.x > size.y ? xAxisHandler : yAxisHandler;
                            handler(value);
                        }, value: size.x > size.y ? size.x : size.y, step: step, min: min, max: isImperial
                            ? Number(getPropertyValue(consts_2.ITEM_STOCK_SIZE_PROPERTIES.STOCK_LENGTH))
                            : Number(getPropertyValue(consts_2.ITEM_STOCK_SIZE_PROPERTIES.STOCK_LENGTH)) * consts_1.consts.INCH_TO_MM, precision: 3, arrows: !isOrderCompleted && !isProjectArchived && !isProjectViewOnly && !isAngledSelected, disabled: isOrderCompleted || isProjectArchived || isProjectViewOnly || isAngledSelected })),
                react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['subtitle'] }, t('item.width') + unitOfMeasurement),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Input_1.default, { type: "number", onChange: (value, error) => {
                            const handler = size.x > size.y ? yAxisHandler : xAxisHandler;
                            handler(value);
                        }, onInput: (value, error) => {
                            const handler = size.x > size.y ? yAxisHandler : xAxisHandler;
                            handler(value);
                        }, value: size.x > size.y ? size.y : size.x, step: step, min: min, max: isImperial
                            ? Number(getPropertyValue(consts_2.ITEM_STOCK_SIZE_PROPERTIES.STOCK_WIDTH))
                            : Number(getPropertyValue(consts_2.ITEM_STOCK_SIZE_PROPERTIES.STOCK_WIDTH)) * consts_1.consts.INCH_TO_MM, precision: 3, arrows: !isOrderCompleted && !isProjectArchived && !isProjectViewOnly && !isAngledSelected, disabled: isOrderCompleted || isProjectArchived || isProjectViewOnly || isAngledSelected })))) : null,
            consts_3.Axis.z in size ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['subtitle'] }, t('item.length') + unitOfMeasurement),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Input_1.default, { type: "number", lengthInput: true, key: `${selectedObjectsUUIDs[0]}-${isImperial}`, value: size.z, onChange: (value, error) => zAxisHandler(value), onInput: (value, error) => zAxisHandler(value), step: step, min: min, max: isImperial
                            ? Number(getPropertyValue(consts_2.ITEM_STOCK_SIZE_PROPERTIES.STOCK_LENGTH))
                            : Number(getPropertyValue(consts_2.ITEM_STOCK_SIZE_PROPERTIES.STOCK_LENGTH)) * consts_1.consts.INCH_TO_MM, precision: 3, arrows: !isOrderCompleted && !isProjectArchived && !isProjectViewOnly && !isAngledSelected, disabled: isOrderCompleted || isProjectArchived || isProjectViewOnly || isAngledSelected })))) : null)));
}
exports.default = ItemSizeEditor;
